import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const InfoCircle: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="filled=no, name=info"><g id="Info Square"><circle id="Ellipse 149" cx="12" cy="12" r="10" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path id="Stroke 3" d="M11.9946 16.0001V12.0001" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path id="Stroke 2" d="M11.9898 8.20432H11.9998" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};